import { getRuntimeConfig } from '@/lib/config/runtime';

export function getAuthToken(): string | undefined {
  try {
    const raw = localStorage.getItem('auth-store');
    if (!raw) {
      return undefined;
    }
    const parsed = JSON.parse(raw);
    return parsed.state?.token;
  } catch {
    return undefined;
  }
}

export function isSignupDisabledRuntime(): boolean {
  const cfg = getRuntimeConfig();
  return cfg.VITE_DISABLE_SIGNUP === 'true' || cfg.VITE_DISABLE_SIGNUP === 'true';
}
